<main class="product" *ngIf="product$ | async as product">
  <div class="product__background">
    <img
      class="product__main-asset"
      src="https://storage.googleapis.com/dev-assets.keys7.com/Rectangle%201769.png"
    />
    <div class="product__gradient-top"></div>
    <div class="product__gradient-bottom"></div>
    <div class="product__gradient-side"></div>
  </div>

  <div class="product__container">
    <div nz-row class="product__top-section">
      <!-- Left section for media/gallery (placeholder for now) -->
      <div nz-col [nzXs]="24" [nzLg]="12" class="product__media-section">
        <div class="product__tags-container">
          <div class="product__tags">
            <nz-tag ngClass="epsilon">DLC</nz-tag>
            <nz-tag ngClass="epsilon">Adventure</nz-tag>
            <nz-tag ngClass="epsilon">Action</nz-tag>
            <nz-tag ngClass="epsilon">RPG</nz-tag>
            <nz-tag ngClass="epsilon">Shooter</nz-tag>
            <nz-tag ngClass="epsilon">Strategy</nz-tag>
            <nz-tag ngClass="epsilon">...</nz-tag>
          </div>
        </div>
      </div>

      <!-- Right section for product information -->
      <div nz-col [nzXs]="24" [nzLg]="12">
        <div class="product__info-container">
          <h1 class="product__title">Helldivers II</h1>

          <div class="product__breadcrumbs">
            <div class="product__breadcrumb-item">
              <span
                class="product__breadcrumb-icon"
                nz-icon
                nzType="ng-zorro:nintendo"
              ></span>
              <span>Nintendo</span>
            </div>
            <div class="product__breadcrumb-item">
              <span
                class="product__breadcrumb-icon"
                nz-icon
                nzType="check"
              ></span>
              <span>Protected Keys</span>
            </div>
            <div class="product__breadcrumb-item">
              <span
                class="product__breadcrumb-icon"
                nz-icon
                nzType="check"
              ></span>
              <span>Digital Download</span>
            </div>
          </div>

          <div class="product__info-card">
            <h2 class="product__sub-title">
              HELLDIVERS 2 WW (Global) EA APP - Standard Edition
            </h2>
            <div class="product__selection-row">
              <div class="product__selection-group">
                <label class="product__selection-label">Platform</label>
                <nz-select
                  nztype="primary"
                  class="product__select"
                  ngClass="beta"
                  [(ngModel)]="selectedPlatform"
                  [nzCustomTemplate]="platformTemplate"
                >
                  <nz-option
                    nzValue="ea_app"
                    nzLabel="EA App"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span
                        class="product__select-icon"
                        nz-icon
                        nzType="ng-zorro:nintendo"
                      ></span>
                      <span>EA App</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="steam"
                    nzLabel="Steam"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span
                        class="product__select-icon"
                        nz-icon
                        nzType="ng-zorro:nintendo"
                      ></span>
                      <span>Steam</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="epic"
                    nzLabel="Epic Games"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span
                        class="product__select-icon"
                        nz-icon
                        nzType="ng-zorro:nintendo"
                      ></span>
                      <span>Epic Games</span>
                    </ng-container>
                  </nz-option>
                </nz-select>
                <ng-template #platformTemplate let-selected>
                  <span
                    class="product__select-icon"
                    nz-icon
                    nzType="ng-zorro:nintendo"
                  ></span>
                  <span>{{ selected.nzLabel }}</span>
                </ng-template>
              </div>

              <div class="product__selection-group">
                <label class="product__selection-label">Edition</label>
                <nz-select
                  nztype="primary"
                  class="product__select"
                  [(ngModel)]="selectedEdition"
                  ngClass="beta"
                  [nzCustomTemplate]="editionTemplate"
                >
                  <nz-option
                    nzValue="standard"
                    nzLabel="Standard"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:tag"></span>
                      <span>Standard</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="deluxe"
                    nzLabel="Deluxe"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:tag"></span>
                      <span>Deluxe</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="ultimate"
                    nzLabel="Ultimate"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:tag"></span>
                      <span>Ultimate</span>
                    </ng-container>
                  </nz-option>
                </nz-select>
                <ng-template #editionTemplate let-selected>
                  <span nz-icon nzType="ng-zorro:tag"></span>
                  <span>{{ selected.nzLabel }}</span>
                </ng-template>
              </div>
            </div>

            <div class="product__selection-row">
              <div
                class="product__selection-group product__selection-group--full"
              >
                <label class="product__selection-label">Region</label>
                <nz-select
                  nztype="primary"
                  class="product__select"
                  [(ngModel)]="selectedRegion"
                  ngClass="beta"
                  [nzCustomTemplate]="regionTemplate"
                >
                  <nz-option
                    nzValue="global"
                    nzLabel="WW (Global)"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:global"></span>
                      <span>WW (Global)</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="eu"
                    nzLabel="Europe"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:europe"></span>
                      <span>Europe</span>
                    </ng-container>
                  </nz-option>
                  <nz-option
                    nzValue="na"
                    nzLabel="North America"
                    [nzCustomContent]="true"
                  >
                    <ng-container>
                      <span nz-icon nzType="ng-zorro:america"></span>
                      <span>North America</span>
                    </ng-container>
                  </nz-option>
                </nz-select>
                <ng-template #regionTemplate let-selected>
                  <span
                    nz-icon
                    [nzType]="
                      'ng-zorro:' +
                      (selectedRegion === 'global' ? 'global' : selectedRegion)
                    "
                  ></span>
                  <span>{{ selected.nzLabel }}</span>
                </ng-template>
              </div>
            </div>

            <div class="product__pricing">
              <div class="product__price-discount">
                <div
                  class="product__discount-badge"
                  *ngIf="discountPercentage > 0"
                >
                  <nz-tag ngClass="zeta" style="background-color: aqua"
                    >-{{ discountPercentage }}%</nz-tag
                  >
                </div>
                <div
                  class="product__price-original"
                  *ngIf="discountPercentage > 0"
                >
                  RRP:
                  <span class="product__price-original-value">
                    49.99€
                    <div
                      style="background-color: aqua"
                      class="product__price-original-value-strike"
                    ></div>
                  </span>
                </div>
              </div>
              <div class="product__price-container">
                <div class="product__price">
                  <span class="product__price-current">
                    19
                    <span class="product__price-cents">.25 €</span>
                  </span>
                </div>
              </div>
            </div>

            <div class="product__vat-info">
              Prices include VAT. Depending on the delivery address, VAT may
              vary at checkout.
              <a href="#" class="product__vat-info-link">More information.</a>
            </div>

            <button
              nz-button
              nzType="primary"
              class="product__purchase-btn"
              (click)="addItemToOrder()"
            >
              <span
                nz-icon
                nzType="ng-zorro:cart_purchase"
                nzSize="medium"
              ></span>
              Purchase
            </button>

            <div class="product__meta">
              <div class="product__meta-row">
                <span class="product__meta-label">Developer:</span>
                <span class="product__meta-value">CD PROJEKT RED</span>
              </div>
              <div class="product__meta-row">
                <span class="product__meta-label">Publisher:</span>
                <span class="product__meta-value">Electronic Arts</span>
              </div>
              <div class="product__meta-row">
                <span class="product__meta-label">Release Date:</span>
                <span class="product__meta-value">25 July 2024</span>
              </div>
              <div class="product__meta-row">
                <span class="product__meta-label">Platforms:</span>
                <span class="product__meta-value product__platform-icons">
                  <span
                    class="product__platform-icon"
                    nz-icon
                    nzType="ng-zorro:nintendo"
                  ></span>
                  <span
                    class="product__platform-icon"
                    nz-icon
                    nzType="ng-zorro:playstation"
                  ></span>
                  <span
                    class="product__platform-icon"
                    nz-icon
                    nzType="ng-zorro:xbox"
                  ></span>
                  <span
                    class="product__platform-icon"
                    nz-icon
                    nzType="ng-zorro:pc"
                  ></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div nz-row class="product__gallery">
      <!-- Main slider with large images -->
      <div class="product__gallery-main">
        <div class="swiper main-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let image of dummyImages">
              <div
                class="product__gallery-image-container"
                (click)="openGalleryModal(image)"
              >
                <img
                  [src]="image"
                  alt="Game Screenshot"
                  class="product__gallery-image"
                />
                <div class="product__gallery-overlay">
                  <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- Navigation buttons -->
          <div
            class="product__gallery-nav product__gallery-nav--prev"
            (click)="goToPrevSlide()"
          >
            <span nz-icon nzType="left"></span>
          </div>
          <div
            class="product__gallery-nav product__gallery-nav--next"
            (click)="goToNextSlide()"
          >
            <span nz-icon nzType="right"></span>
          </div>
        </div>
      </div>

      <!-- Pagination dots -->
      <div class="product__gallery-pagination">
        <span
          *ngFor="let image of dummyImages; let i = index"
          class="product__gallery-dot"
          [ngClass]="{ 'product__gallery-dot--active': i === currentIndex }"
          (click)="goToSlide(i)"
          style="background-color: aqua"
        >
        </span>
      </div>
    </div>

    <!-- Game Features Section -->
    <div class="product__sections">
      <div class="product__sections-header">
        <h2 class="product__sections-title">Throw Yourself Into Freedom</h2>
      </div>

      <!-- First section: Image left, text right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-left"
          style="border-color: aqua"
        >
          <img
            [src]="dummyImages[0]"
            alt="Game Screenshot"
            class="product__feature-asset"
          />
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-right"
          style="border-color: aqua"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Fight For Super-Earth!
          </h3>
          <p class="product__feature-text">
            Freedom. Peace. Managed democracy. The inherent rights of all
            citizens of Over-Earth. The foundations of our civilization are
            under attack by deadly alien creatures conspiring to destroy your
            planet and its values.
          </p>
          <p class="product__feature-text">
            The Helldivers must take on the role of peacemakers in this galactic
            war and protect their home planet, spread the message of democracy
            and violently deter enemies.
          </p>
        </div>
      </div>

      <!-- Second section: Text left, image right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-left"
          style="border-color: aqua"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Use Powerful Weapons!
          </h3>
          <p class="product__feature-text">
            Decide how to defend each wave of enemy attacks, using a variety of
            offensive and defensive weapons.
          </p>
          <p class="product__feature-text">
            Need to take out a large influx of Terminids in one fell swoop? Call
            in a Hellpod, drop a 500kg bomb and leave nothing but fried Bug
            corpses. Need to stake out a defensive perimeter? Call in an
            Anti-Personnel Minelayer to booby-trap the battlefield.
          </p>
          <p class="product__feature-text">
            As you complete missions, you can upgrade your ship and build an
            even more impressive arsenal. Everything from shield generators to
            gun turrets to large-scale airstrikes can be used to give your team
            the upper hand.
          </p>
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-right"
          style="border-color: aqua"
        >
          <img
            [src]="dummyImages[1]"
            alt="Game Screenshot"
            class="product__feature-asset"
          />
        </div>
      </div>

      <!-- Third section: Image left, text right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-left"
          style="border-color: aqua"
        >
          <img
            [src]="dummyImages[2]"
            alt="Game Screenshot"
            class="product__feature-asset"
          />
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-right"
          style="border-color: aqua"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Aim Carefully!
          </h3>
          <p class="product__feature-text">
            They say everything is better with friends, especially when it comes
            to bringing destruction to the enemies of freedom! But be warned:
            for maximum challenge and cooperation, you always have to expect
            friendly fire!
          </p>
          <p class="product__feature-text">
            Communicate with your teammates and make sure you only use your
            arsenal to take out enemies.
          </p>
        </div>
      </div>
    </div>

    <!-- Featured Product Section -->
    <div class="product__sections">
      <div class="product__sections-header product__sections-header--big">
        <h2 class="product__sections-title">
          From Standard To Legendary—Your Edition Awaits!
        </h2>
      </div>
      <div class="product__background product__sections-background">
        <img
          class="product__main-asset product__sections-main-asset"
          src="https://storage.googleapis.com/dev-assets.keys7.com/Rectangle%201769.png"
        />
        <div class="product__gradient-top"></div>
        <div class="product__gradient-bottom"></div>
        <div class="product__gradient-side"></div>
      </div>

      <div class="product__sections--container">
        <div nz-row [nzGutter]="[50, 50]">
          <div nz-col [nzXs]="24" [nzXl]="12">
            <div
              class="product__featured-card product__featured-card--selected"
            >
              <!-- Left side - Game cover image -->
              <div class="product__featured-image-wrapper">
                <div class="product__featured-discount-badge-top">-23%</div>
                <img
                  [src]="dummyImages[1]"
                  alt="Helldivers Super Citizen Edition"
                  class="product__featured-image"
                />
              </div>

              <!-- Right side - Product details -->
              <div class="product__featured-details">
                <h3 class="product__featured-title">Super Citizen Edition</h3>

                <!-- Price box with border -->
                <div class="product__featured-price-box">
                  <div class="product__featured-price-label">Price</div>
                  <div class="product__featured-price-content">
                    <div
                      style="background-color: aqua"
                      class="product__featured-discount-badge"
                    >
                      -23%
                    </div>
                    <div class="product__featured-price-amount">
                      <span class="product__featured-price-number">19</span>
                      <span class="product__featured-price-cents">25 €</span>
                    </div>
                  </div>
                  <div class="product__featured-original-price">
                    RRP:
                    <span class="product__featured-original-value">
                      40.99€
                    </span>
                    <span
                      class="product__featured-info-icon"
                      nz-icon
                      nzType="info-circle"
                      nzTheme="outline"
                    ></span>
                  </div>
                </div>

                <!-- Features list -->
                <div class="product__featured-features">
                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >HELLDIVERS™ 2</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Savior Of Freedom DP-53" Armor</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Will Of The People" Cloak</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"MP-98 Knight" Weapon</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >Super-Citizen Status</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span class="product__featured-check"></span>
                    <span class="product__featured-feature-text"
                      >Equipment Hero Game On The Ship</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Steeled Veterans" War Bond</span
                    >
                  </div>
                </div>

                <!-- CTA Button -->
                <button
                  nz-button
                  nzType="primary"
                  class="product__select-edition"
                  nzSize="large"
                  disabled="true"
                >
                  <span
                    nz-icon
                    nzType="shopping-cart"
                    class="product__select-edition--icon"
                  ></span>
                  Select Edition
                </button>
              </div>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzXl]="12">
            <div class="product__featured-card">
              <!-- Left side - Game cover image -->
              <div class="product__featured-image-wrapper">
                <div class="product__featured-discount-badge-top">-23%</div>
                <img
                  [src]="dummyImages[1]"
                  alt="Helldivers Super Citizen Edition"
                  class="product__featured-image"
                />
              </div>

              <!-- Right side - Product details -->
              <div class="product__featured-details">
                <h3 class="product__featured-title">Super Citizen Edition</h3>

                <!-- Price box with border -->
                <div class="product__featured-price-box">
                  <div class="product__featured-price-label">Price</div>
                  <div class="product__featured-price-content">
                    <div
                      style="background-color: aqua"
                      class="product__featured-discount-badge"
                    >
                      -23%
                    </div>
                    <div class="product__featured-price-amount">
                      <span class="product__featured-price-number">19</span>
                      <span class="product__featured-price-cents">25 €</span>
                    </div>
                  </div>
                  <div class="product__featured-original-price">
                    RRP:
                    <span class="product__featured-original-value">40.99€</span>
                    <span
                      class="product__featured-info-icon"
                      nz-icon
                      nzType="info-circle"
                      nzTheme="outline"
                    ></span>
                  </div>
                </div>

                <!-- Features list -->
                <div class="product__featured-features">
                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >HELLDIVERS™ 2</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Savior Of Freedom DP-53" Armor</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Will Of The People" Cloak</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"MP-98 Knight" Weapon</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >Super-Citizen Status</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span class="product__featured-check"></span>
                    <span class="product__featured-feature-text"
                      >Equipment Hero Game On The Ship</span
                    >
                  </div>

                  <div class="product__featured-feature">
                    <span
                      class="product__featured-check"
                      nz-icon
                      nzType="check"
                    ></span>
                    <span class="product__featured-feature-text"
                      >"Steeled Veterans" War Bond</span
                    >
                  </div>
                </div>

                <!-- CTA Button -->
                <button
                  nz-button
                  nzType="primary"
                  class="product__select-edition"
                  nzSize="large"
                >
                  <span
                    nz-icon
                    nzType="shopping-cart"
                    class="product__select-edition--icon"
                  ></span>
                  Select Edition
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Critics Review Section -->
    <div class="product__critics">
      <div class="product__critics-container">
        <div class="product__critics-scores-wrapper">
          <div class="product__critics-brand">
            <img
              src="https://img.opencritic.com/mighty-man/strong-man.png"
              alt="Critics Brand Logo"
              class="product__critics-logo"
            />
          </div>

          <div class="product__critics-scores">
            <div class="product__critics-score-item">
              <div class="product__critics-score-circle">
                <nz-progress
                  [nzType]="'circle'"
                  [nzPercent]="criticTopScore"
                  [nzWidth]="160"
                  [nzStrokeColor]="'#ff369f'"
                  [nzStrokeWidth]="15"
                  [nzFormat]="formatCriticTopScore"
                ></nz-progress>
              </div>
              <div class="product__critics-score-label">
                <span>Top Critic Average</span>
              </div>
            </div>

            <div class="product__critics-score-item">
              <div class="product__critics-score-circle">
                <nz-progress
                  [nzType]="'circle'"
                  [nzPercent]="criticRecommendPercentage"
                  [nzWidth]="160"
                  [nzStrokeColor]="'#ff369f'"
                  [nzStrokeWidth]="15"
                  [nzFormat]="formatCriticRecommendPercentage"
                ></nz-progress>
              </div>
              <div class="product__critics-score-label">
                <span>Critics Recommend</span>
              </div>
            </div>
          </div>
        </div>

        <h2 class="product__critics-title">What Critics Are Saying</h2>

        <div class="product__critics-list">
          <div
            class="product__critics-review"
            *ngFor="let review of criticReviews"
          >
            <div class="product__critics-review-border"></div>
            <div class="product__critics-review-content-wrapper">
              <div class="product__critics-top">
                <div class="product__critics-publication">
                  {{ review.publication }}
                </div>
                <div class="product__critics-reviewer">
                  {{ review.reviewer }}
                </div>
                <div class="product__critics-review-score">
                  {{ review.score }} / {{ review.maxScore }}
                </div>
                <div class="product__critics-review-content">
                  {{ review.content }}
                </div>
              </div>
              <a href="javascript:void(0)" class="product__critics-read-more"
                >Read full review</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Game Features Section -->
    <div
      class="product__sections product__sections--beta"
      style="border-color: aqua"
    >
      <div
        class="product__sections--hexagon"
        style="background-color: #00ffff14"
      ></div>
      <div class="product__sections-header">
        <h3 style="color: aqua" class="product__sections-title--sub">
          Invest in freedom, peace and democracy on Earth above.
        </h3>
        <h2 class="product__sections-title">Throw Yourself Into Freedom</h2>
      </div>

      <!-- First section: Image left, text right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-left"
          style="border-color: aqua"
        >
          <video
            autoplay="true"
            loop="true"
            class="product__feature-asset"
            src="https://gmedia.playstation.com/is/content/SIEPDC/global_pdc/en/games/pdps/h/he/helldivers-2/videos/helldivers-2-video-block-01-en-06dec23.mp4"
          ></video>
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-right"
          style="border-color: aqua"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Fight For Super-Earth!
          </h3>
          <p class="product__feature-text">
            Freedom. Peace. Managed democracy. The inherent rights of all
            citizens of Over-Earth. The foundations of our civilization are
            under attack by deadly alien creatures conspiring to destroy your
            planet and its values.
          </p>
          <p class="product__feature-text">
            The Helldivers must take on the role of peacemakers in this galactic
            war and protect their home planet, spread the message of democracy
            and violently deter enemies.
          </p>
        </div>
      </div>

      <!-- Second section: Text left, image right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-left"
          style="border-color: aqua"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Use Powerful Weapons!
          </h3>
          <p class="product__feature-text">
            Decide how to defend each wave of enemy attacks, using a variety of
            offensive and defensive weapons.
          </p>
          <p class="product__feature-text">
            Need to take out a large influx of Terminids in one fell swoop? Call
            in a Hellpod, drop a 500kg bomb and leave nothing but fried Bug
            corpses. Need to stake out a defensive perimeter? Call in an
            Anti-Personnel Minelayer to booby-trap the battlefield.
          </p>
          <p class="product__feature-text">
            As you complete missions, you can upgrade your ship and build an
            even more impressive arsenal. Everything from shield generators to
            gun turrets to large-scale airstrikes can be used to give your team
            the upper hand.
          </p>
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-right"
          style="border-color: aqua"
        >
          <video
            autoplay="true"
            loop="true"
            class="product__feature-asset"
            src="https://gmedia.playstation.com/is/content/SIEPDC/global_pdc/en/games/pdps/h/he/helldivers-2/videos/helldivers-2-video-block-02-en-06dec23.mp4"
          ></video>
        </div>
      </div>

      <!-- Third section: Image left, text right -->
      <div nz-row class="product__feature-row">
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-asset-container product__feature-asset-left"
          style="border-color: aqua"
        >
          <video
            autoplay="true"
            loop="true"
            class="product__feature-asset"
            src="https://gmedia.playstation.com/is/content/SIEPDC/global_pdc/en/games/pdps/h/he/helldivers-2/videos/helldivers-2-video-block-03-en-06dec23.mp4"
          ></video>
        </div>
        <div
          nz-col
          [nzXs]="24"
          [nzMd]="12"
          class="product__feature-content product__feature-content-right"
        >
          <h3 style="color: aqua" class="product__feature-title">
            Aim Carefully!
          </h3>
          <p class="product__feature-text">
            They say everything is better with friends, especially when it comes
            to bringing destruction to the enemies of freedom! But be warned:
            for maximum challenge and cooperation, you always have to expect
            friendly fire!
          </p>
          <p class="product__feature-text">
            Communicate with your teammates and make sure you only use your
            arsenal to take out enemies.
          </p>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="product__sections">
      <div class="product__sections-header">
        <h2 class="product__sections-title product__faq-title">
          HELLDIVERS 2 – FAQS
        </h2>
        <span
          class="product__faq-icon"
          nz-icon
          nzType="question-circle"
          nzTheme="outline"
        ></span>
      </div>

      <div class="product__faq-container">
        <!-- FAQ Item 1 -->
        <div
          class="product__faq-item"
          [ngClass]="{ 'product__faq-item--active': openFaqIndex === 0 }"
          (click)="toggleFaq(0)"
        >
          <div class="product__faq-question">
            <span>Should I play the first Helldivers game first?</span>
            <span
              class="product__faq-toggle"
              nz-icon
              [nzType]="openFaqIndex === 0 ? 'up' : 'down'"
            ></span>
          </div>
          <div
            class="product__faq-answer"
            [ngClass]="{ 'product__faq-answer--visible': openFaqIndex === 0 }"
          >
            <p>
              Helldivers 2 is not a continuation of an ongoing story, so you
              don't need to have played the original game released in 2015.
              However, we highly recommend checking it out anyway, as it has
              received very good reviews.
            </p>
          </div>
        </div>

        <!-- FAQ Item 2 -->
        <div
          class="product__faq-item"
          [ngClass]="{ 'product__faq-item--active': openFaqIndex === 1 }"
          (click)="toggleFaq(1)"
        >
          <div class="product__faq-question">
            <span>Can I play Helldivers 2 offline?</span>
            <span
              class="product__faq-toggle"
              nz-icon
              [nzType]="openFaqIndex === 1 ? 'up' : 'down'"
            ></span>
          </div>
          <div
            class="product__faq-answer"
            [ngClass]="{ 'product__faq-answer--visible': openFaqIndex === 1 }"
          >
            <p>
              No, Helldivers 2 requires an internet connection to play. The game
              is focused on cooperative gameplay and connects to servers for
              matchmaking and progression tracking.
            </p>
          </div>
        </div>

        <!-- FAQ Item 3 -->
        <div
          class="product__faq-item"
          [ngClass]="{ 'product__faq-item--active': openFaqIndex === 2 }"
          (click)="toggleFaq(2)"
        >
          <div class="product__faq-question">
            <span>Is there a special edition of Helldivers 2?</span>
            <span
              class="product__faq-toggle"
              nz-icon
              [nzType]="openFaqIndex === 2 ? 'up' : 'down'"
            ></span>
          </div>
          <div
            class="product__faq-answer"
            [ngClass]="{ 'product__faq-answer--visible': openFaqIndex === 2 }"
          >
            <p>
              Yes, Helldivers 2 is available in both Standard and Super Citizen
              Special Edition. The Super Citizen Edition includes additional
              armor sets, weapons, capes, and other cosmetic items to customize
              your Helldiver.
            </p>
          </div>
        </div>

        <!-- FAQ Item 4 -->
        <div
          class="product__faq-item"
          [ngClass]="{ 'product__faq-item--active': openFaqIndex === 3 }"
          (click)="toggleFaq(3)"
        >
          <div class="product__faq-question">
            <span>Which studio developed Helldivers 2?</span>
            <span
              class="product__faq-toggle"
              nz-icon
              [nzType]="openFaqIndex === 3 ? 'up' : 'down'"
            ></span>
          </div>
          <div
            class="product__faq-answer"
            [ngClass]="{ 'product__faq-answer--visible': openFaqIndex === 3 }"
          >
            <p>
              Helldivers 2 was developed by Arrowhead Game Studios, the same
              team that created the original Helldivers. The game was published
              by Sony Interactive Entertainment.
            </p>
          </div>
        </div>

        <!-- FAQ Item 5 -->
        <div
          class="product__faq-item"
          [ngClass]="{ 'product__faq-item--active': openFaqIndex === 4 }"
          (click)="toggleFaq(4)"
        >
          <div class="product__faq-question">
            <span
              >Will there be add-on packs for Helldivers 2 after release?</span
            >
            <span
              class="product__faq-toggle"
              nz-icon
              [nzType]="openFaqIndex === 4 ? 'up' : 'down'"
            ></span>
          </div>
          <div
            class="product__faq-answer"
            [ngClass]="{ 'product__faq-answer--visible': openFaqIndex === 4 }"
          >
            <p>
              Yes, Arrowhead Game Studios has confirmed plans for post-launch
              content for Helldivers 2. This will include free updates with new
              missions and enemies, as well as paid DLC with additional weapons,
              armor sets, and customization options.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Gallery Modal -->
<nz-modal
  [nzVisible]="isGalleryModalVisible"
  [nzTitle]="''"
  [nzFooter]="null"
  [nzWidth]="'100vw'"
  [nzCentered]="true"
  [nzBodyStyle]="{ padding: '0' }"
  [nzStyle]="{ top: '0', margin: '0' }"
  [nzWrapClassName]="'product__gallery-modal-fullscreen'"
  nzClassName="product__gallery-modal"
  [nzClosable]="false"
>
  <ng-container *nzModalContent>
    <div class="product__gallery-modal-content">
      <div class="product__gallery-modal-image-container">
        <img
          [src]="selectedGalleryImage"
          alt="Full size image"
          class="product__gallery-modal-image"
        />
      </div>

      <div class="product__gallery-modal-counter">
        {{ currentImageIndex + 1 }} / {{ dummyImages.length }}
      </div>

      <button
        class="product__gallery-modal-nav product__gallery-modal-nav--prev"
        (click)="showPrevImage()"
      >
        <span nz-icon nzType="left" nzTheme="outline"></span>
      </button>

      <button
        class="product__gallery-modal-nav product__gallery-modal-nav--next"
        (click)="showNextImage()"
      >
        <span nz-icon nzType="right" nzTheme="outline"></span>
      </button>

      <button
        class="product__gallery-modal-close"
        (click)="closeGalleryModal()"
      >
        <span nz-icon nzType="close" nzTheme="outline"></span>
      </button>
    </div>
  </ng-container>
</nz-modal>
